// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/cloud-base.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/cloud-base/cloud-base.js';

mount([g0]);
